import React from 'react';
import { Typography, Alert, Table, TableBody, TableRow, TableCell } from '@mui/material';
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';
import { makePriceLabelRoundAE } from '../../../utils/helpers/make-price-label';
import PropTypes from 'prop-types';

const PoliciesAndFaqs = ({ isFaqPage = false }) => {
    return (
        <div>
            <Typography className={` mb-3`}>
                {!isFaqPage && <ArrowRightRoundedIcon sx={{ marginLeft: '-2.3rem' }} className='h-10 w-10 mr-3 -mt-2 absolute inline-block text-primary' />}
                Is there any forfeitures after winning this auction ?
            </Typography>
            <div>
                <Alert icon={<></>} severity="success" classes={{ message: 'text-white' }} className='font-bold text-lg shadow-inner bg-border'>If car value less than 150 thousand AED</Alert>
                <Table aria-label="simple table">
                    <TableBody className='bg-background px-4 pb-4 pt-2 my-2 text-center'>
                        <TableRow>
                            <TableCell align="left">Payment made within 18 hrs</TableCell>
                            <TableCell align="center" className='text-light-text'>No penalty</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">Payment made between 18 hrs to 96 hrs</TableCell>
                            <TableCell align="center" className='text-light-text'>5% of invoice value</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">Payment not made after 96 hrs (considered as backout)</TableCell>
                            <TableCell align="center" className='text-light-text'>10% of invoice value</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
            <div className='mt-6'>
                <Alert icon={<></>} severity="success" classes={{ message: 'text-white' }} className='font-bold text-lg shadow-inner bg-border'>If car value greater than 150 thousand AED</Alert>
                <Table aria-label="simple table">
                    <TableBody className='bg-background px-4 pb-4 pt-2 my-2 text-center'>
                        <TableRow>
                            <TableCell align="left">15% of token with 15 hours (for car allocation)</TableCell>
                            <TableCell align="center" className='text-light-text'>No penalty</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">Full payment made within 18 hours</TableCell>
                            <TableCell align="center" className='text-light-text'>No penalty</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">Payment made between 18 hrs to 96 hrs</TableCell>
                            <TableCell align="center" className='text-light-text'>5% of invoice value</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">Payment not made after 96 hrs (considered as backout)</TableCell>
                            <TableCell align="center" className='text-light-text'>10% of invoice value</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
            <Typography className=' mb-3 mt-4'>
                {!isFaqPage && <ArrowRightRoundedIcon sx={{ marginLeft: '-2.3rem' }} className='h-10 w-10 mr-3 -mt-2 absolute inline-block text-primary' />}
                Are extra charges applicable while buying a car ?
            </Typography>
            <div>
                <Alert icon={<></>} severity="success" classes={{ message: 'text-white' }} className='font-bold text-lg shadow-inner bg-border'>Service fees (transfer, delivery, processing) will be based on the customer’s emirate.</Alert>
                <Table aria-label="simple table" className='mt-4'>
                    <TableBody className='bg-background px-4 pb-4 pt-2 my-2 text-center'>
                        <TableRow>
                            <TableCell align="left">Dubai</TableCell>
                            <TableCell align="center" className='whitespace-nowrap text-light-text'>{makePriceLabelRoundAE(1099)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">Abu Dhabi</TableCell>
                            <TableCell align="center" className='whitespace-nowrap text-light-text'>{makePriceLabelRoundAE(1499)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">Fujairah</TableCell>
                            <TableCell align="center" className='whitespace-nowrap text-light-text'>{makePriceLabelRoundAE(1499)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">Ras Al Khaimah</TableCell>
                            <TableCell align="center" className='whitespace-nowrap text-light-text'>{makePriceLabelRoundAE(1499)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">Sharjah</TableCell>
                            <TableCell align="center" className='whitespace-nowrap text-light-text'>{makePriceLabelRoundAE(1299)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">Ajman</TableCell>
                            <TableCell align="center" className='whitespace-nowrap text-light-text'>{makePriceLabelRoundAE(1299)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">Umm Al Quwain</TableCell>
                            <TableCell align="center" className='whitespace-nowrap text-light-text'>{makePriceLabelRoundAE(1299)}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
            {!isFaqPage && <React.Fragment>
                <Typography className=' mb-3 mt-4'>
                    <ArrowRightRoundedIcon sx={{ marginLeft: '-2.3rem' }} className='h-10 w-10 mr-3 -mt-2 absolute inline-block text-primary' />
                    After what time will my bid expire?
                </Typography>
                <Typography className='text-light-text'>
                    Bid is valid till 48 hours from bid submission;  Or till car gets transferred, if allocated to buyer.
                </Typography>
                <Typography className=' mb-3 mt-4'>
                    <ArrowRightRoundedIcon sx={{ marginLeft: '-2.3rem' }} className='h-10 w-10 mr-3 -mt-2 absolute inline-block text-primary' />
                    How can I cancel a bid or purchase?
                </Typography>
                <Typography className='text-light-text'>
                    A bid or purchase is a binding contract. Once it has been placed, it cannot be lowered, cancelled or retracted.
                </Typography>
                <Typography className=' mb-3 mt-4'>
                    <span>Note :</span> All checkpoints with Green Tick are re-verified for accuracy by Cars24.
                </Typography>
            </React.Fragment>}
        </div>
    );
};

PoliciesAndFaqs.propTypes = {
    isFaqPage: PropTypes.bool
};

export default PoliciesAndFaqs;
